import { render } from "./BillingPayment.vue?vue&type=template&id=55d4ac60"
import script from "./BillingPayment.vue?vue&type=script&lang=js"
export * from "./BillingPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__